module.exports = __webpack_public_path__ + "img/how_to_access_profile.6961231d.png";